import React, { Component } from 'react'
import Logo from '../../img/banner_logo.png'
import { Link, Redirect } from 'react-router-dom'
import { logout } from '../../store/actions/user'
import { connect } from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faReceipt, faTicketAlt, faChartLine, faUserFriends, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

import './styles.css'

class Footer extends Component {

    state = {
        token: '',
        nome: '',
        redirect: false
    }

    fazerLogout = async () => {
        await this.props.onLogout()
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>RS Refeições</h1>
                        <p>Logout realizado!</p>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-50"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Ok
                        </button>
                    </div>
                )
            }
        })
        await this.setState({ redirect: true })
    }

    render() {
        return (
            <div className="footer_wrapper">
                {this.state.redirect &&
                    <Redirect to={'/'} />
                }
                <div className='footer_nav'>
                    <div className={`footer_item ${this.props.selected === "PEDIDOS" ? "footer_selected": ""}`}>
                        <Link to={{ pathname: `/pedidos` }}>
                            <FontAwesomeIcon icon={faReceipt} size="2x" color='white' />
                        </Link>
                    </div>
                    <div className={`footer_item ${this.props.selected === "VOUCHERS" ? "footer_selected" : ""}`}>
                        <Link to={{ pathname: `/vouchers` }}>
                            <FontAwesomeIcon icon={faTicketAlt} size="2x" color='white' />
                        </Link>
                    </div>
                    <div className={`footer_item ${this.props.selected === "USUARIOS" ? "footer_selected" : ""}`}>
                        <Link to={{ pathname: `/usuarios` }}>
                            <FontAwesomeIcon icon={faUserFriends} size="2x" color='white' />
                        </Link>
                    </div>
                    <div className={`footer_item ${this.props.selected === "RELATORIOS" ? "footer_selected" : ""}`}>
                        <Link to={{ pathname: `/relatorios` }}>
                            <FontAwesomeIcon icon={faChartLine} size="2x" color='white' />
                        </Link>
                    </div>
                    <div className={`footer_item`}>
                        <FontAwesomeIcon cursor="pointer" onClick={() => this.fazerLogout()} icon={faSignOutAlt} color="white" size='2x' />
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLogout: user => dispatch(logout(user))
    }
}

export default connect(null, mapDispatchToProps)(Footer)